<template>
  <div id="createPatent">
    <div>
      <el-tabs type="border-card" style="min-height:800px" v-model="tabs" @tab-click="handleClick">
        <el-tab-pane label="发布专利" name="1">
          <div>
            <el-form :model="form" ref="form" :rules="rules" label-width="100px">
              <el-form-item label="专利号：" class="item_width" prop="code">
                <el-input v-model="form.code"></el-input>
              </el-form-item>
              <el-form-item label="专利名称：" class="item_width" prop="name">
                <el-input v-model="form.name"></el-input>
              </el-form-item>
              <el-form-item label="关键词：" class="item_width" prop="keyword">
                <el-input v-model="form.keyword"></el-input>
              </el-form-item>
              <el-form-item label="有效期：" class="item_width" prop="end_time">
                <el-input v-model="form.end_time" placeholder="请输入有效期截止日期,如:2020-10-01"></el-input>
              </el-form-item>
              <el-form-item label="估价：" prop="price" class="item_width input-with-select">
                <el-input v-model="form.price">
                  <el-select v-model="priceUnit" slot="prepend" placeholder="请选择单位">
                    <el-option label="万元" value="万元"></el-option>
                    <el-option label="元" value="元"></el-option>
                  </el-select>
                </el-input>
              </el-form-item>
              <el-form-item label="专利状态：" class="item_width" prop="status">
                <el-radio-group v-model="form.status">
                  <el-radio label="1">待融资</el-radio>
                  <el-radio label="2">已融资</el-radio>
                  <el-radio label="3">待交易</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="专利类型：" class="item_width" prop="type">
                <el-radio-group v-model="form.type">
                  <el-radio label="1">国际专利</el-radio>
                  <el-radio label="2">国内专利</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="专利详情：">
                <wanged-itor @change_edit="change_edit"></wanged-itor>
              </el-form-item>
            </el-form>
          </div>
          <div class="button-box">
            <el-button
              style="width:220px"
              type="primary"
              @click="submitForm('form')"
              class="save_button"
            >发&nbsp;&nbsp;&nbsp;&nbsp;布</el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="我的专利" name="2">
          <div class="my_patents clearfix" v-if="patentsList.length > 0">
            <div class="patent-box" v-for="item in patentsList" :key="item.id">
              <div class="icon_close" @click="zhuan_close(item.id)">
                <i class="el-icon-close"></i>
              </div>
              <div class="patent_img">
                <img :src="item.image" alt />
              </div>
              <div class="patent_title">{{item.name}}</div>
              <div style="margin-top:11px" class="money">&yen;{{item.price}}</div>
              <div class="pay_button_box">
                <el-button
                  class="pay_button"
                  @click="editStatus = true,editId = item.id"
                >{{item.button_text}}</el-button>
              </div>
            </div>
          </div>
          <div v-else>
            <img style="margin:0 auto;" :src="serve + '/image/none/patentsNone.jpg'" alt="暂无图片" />
          </div>
          <div style="text-align:right">
            <el-pagination
              background
              layout="total , prev, pager, next"
              hide-on-single-page
              :page-size="12"
              @current-change="setPage"
              :current-page="page"
              :total="total"
            ></el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog title="请选择要改变的状态" :visible.sync="editStatus" width="30%">
      <el-radio-group v-model="checkStatus">
        <el-radio :label="1">待融资</el-radio>
        <el-radio :label="2">已融资</el-radio>
        <el-radio :label="3">待交易</el-radio>
        <el-radio :label="4">已交易</el-radio>
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editStatus = false">取 消</el-button>
        <el-button type="primary" @click="submitEditStatus">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import wangedItor from "../../../components/wangeditor";
export default {
  components: {
    wangedItor
  },
  data() {
    return {
      tabs: "1",
      serve: this.$store.state.serve,
      form: {
        name: "",
        keyword: "",
        end_time: "",
        status: "",
        type: ""
      },
      rules: {
        code: [{ required: true, message: "请输入专利号", trigger: "blur" }],
        name: [{ required: true, message: "请输入专利名称", trigger: "blur" }],
        keyword: [{ required: true, message: "请填写关键字", trigger: "blur" }],
        end_time: [
          { required: true, message: "请填写有效期", trigger: "blur" }
        ],
        price: [{ required: true, message: "请输入专利估价", trigger: "blur" }],
        status: [
          { required: true, message: "请选择专利状态", trigger: "change" }
        ],
        type: [{ required: true, message: "请选择专利类型", trigger: "change" }]
      },
      patentsList: [],
      priceUnit: "",
      total: 0,
      page: 1,
      editStatus: false,
      editId: 0,
      checkStatus: 0
    };
  },
  activated() {
    this.$store.state.user_location = "发布信息";
  },
  created() {
    this.token = this.$cookies.get("token");
    this.mobile = this.$cookies.get("user");
  },
  methods: {
    zhuan_close(id) {
      this.axios.get(this.serve + "/deletePatent", {
        params: {
          mobile: this.mobile,
          token: this.token,
          id
        }
      }).then(res=>{
         if (res.data.status == "success") {
            this.myPatentsList();
            this.$message({
              type: "success",
              message: "删除成功",
              offset: "300"
            });
          } else if (res.data.status == "error") {
            this.$message({
              type: "error",
              message:res.data.msg,
              offset: "300"
            });
          }
      });
    },
    submitEditStatus() {
      if (this.checkStatus == 0) {
        this.$message({
          showClose: true,
          message: "请选择状态类型",
          type: "error",
          offset: 300
        });
        return;
      }
      var where = {
        mobile: this.mobile,
        token: this.token,
        id: this.editId,
        status: this.checkStatus
      };
      this.axios
        .get(this.serve + "/statusPatent", { params: where })
        .then(res => {
          this.editStatus = false;
          this.editId = 0;
          this.checkStatus = 0;
          var data = res.data;
          if (data.status == "success") {
            this.$message({
              showClose: true,
              message: "状态修改成功",
              type: "success",
              offset: 300
            });
            this.myPatentsList();
          } else {
            this.$message({
              showClose: true,
              message: "状态修改失败",
              type: "error",
              offset: 300
            });
          }
        });
    },
    handleClick(tab) {
      if (tab.name == 2) {
        this.myPatentsList();
      }
    },
    setPage(page) {
      this.page = page;
      this.myPatentsList();
    },
    change_edit(data) {
      this.form.info = data;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          var qs = require("qs");
          let config = {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          };
          var form = this.form;
          form.price = form.price + this.priceUnit;
          form.mobile = this.mobile;
          form.token = this.token;
          this.axios
            .post(this.serve + "/createPatent", qs.stringify(form), config)
            .then(res => {
              var data = res.data;
              if (data.status == "success") {
                this.$message({
                  showClose: true,
                  message: "您的专利已经发布成功",
                  type: "success",
                  offset: 300
                });
                this.form = {
                  name: "",
                  keyword: "",
                  end_time: "",
                  status: "",
                  type: "",
                  info: ""
                };
              } else {
                this.$message({
                  showClose: true,
                  message: "您的专利发布失败,请检查您的参数",
                  type: "error",
                  offset: 300
                });
              }
            });
        }
      });
    },
    myPatentsList() {
      var where = {};
      where.mobile = this.mobile;
      where.token = this.token;
      where.page = this.page;
      this.axios
        .get(this.serve + "/myPatentList", { params: where })
        .then(res => {
          var data = res.data;
          if (data.status == "success") {
            var patentList = data.data.results;
            for (var i = 0; i < patentList.length; i++) {
              switch (parseInt(patentList[i].status)) {
                case 0:
                  patentList[i].button_text = "暂无状态";
                  break;
                case 1:
                  patentList[i].button_text = "待融资";
                  break;
                case 2:
                  patentList[i].button_text = "已融资";
                  break;
                case 3:
                  patentList[i].button_text = "待交易";
                  break;
                case 4:
                  patentList[i].button_text = "已交易";
                  break;
              }
            }
            this.patentsList = patentList;
            this.total = data.data.total;
          } else {
            this.patentsList = [];
          }
        });
    }
  }
};
</script>
<style lang="scss">
.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.el-select {
  width: 130px;
}
#createPatent {
  .button-box {
    font-weight: 200;
    text-align: center;
    padding: 30px 0 60px 0;
  }
  .item_width {
    width: 500px;
  }
  .my_patents {
    padding: 0 0 0 0;
  }
  .patent-box:hover .icon_close {
    opacity: 1;
    transition: all 0.3s;
  }
  .patent-box {
    width: 210px;
    height: 260px;
    background: rgba(254, 254, 254, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    float: left;
    margin: 8px 10px 8px 10px;
    position: relative;
    .icon_close {
      transition: all 0.3s;
      opacity: 0;
      position: absolute;
      top: 3px;
      right: 3px;
      cursor: pointer;
    }
    .icon_close :hover {
      color: #e2211c;
    }
    .patent_img {
      margin: 20px auto 15px auto;
      width: 170px;
      height: 126px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .patent_title {
      font-size: 14px;
      font-family: "Microsoft YaHei";
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      margin-left: 20px;
      overflow: hidden;
      cursor: pointer;
    }
    .money {
      font-size: 14px;
      font-family: "Microsoft YaHei";
      font-weight: 400;
      color: #e2211c;
      margin-left: 20px;
    }
    .pay_button_box {
      margin-top: 11px;
      text-align: center;
      .pay_button {
        width: 96px;
        height: 28px;
        background: rgba(75, 90, 183, 0);
        border: 1px solid rgba(221, 221, 221, 1);
        color: black;
        padding: 0;
        border-radius: 0;
      }
      .pay_button:hover {
        width: 98px;
        height: 30px;
        background: rgba(238, 238, 238, 1);
        border: 0;
      }
    }
  }
  .el-tabs--border-card > .el-tabs__header .el-tabs__item {
    border-top: 3px solid #f5f7fa;
  }
  .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
    border-top: 3px solid #e2211c;
  }
}
</style>